import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { PointCardTemplate } from 'components/Templates'

const PointCard: FC = () => {
  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'ポイントカード'} title={'ポイントカード'}>
      <PointCardTemplate />
    </Layout>
  )
}

export default PointCard
